import { AuthRefreshToken, AuthToken } from '../models/auth/AuthToken';
import { AuthConfig } from '../models/auth/AuthConfig';

/**
 * Ключ, под которым токены сохраняются в `localStorage`.
 */
const STORAGE_KEY_TOKENS = 'app.auth';
const STORAGE_KEY_CONFIG = 'app.auth.config';

// ========== TOKENS ==========

/**
 * Сохраняет токены в `localStorage`, автоматически рассчитывая срок действия (`valid_until`).
 *
 * @param tokens Объект токенов, полученных с backend'а, включая `expires_in` (в секундах).
 *               Все поля из `AuthStorage`, кроме `valid_until`, плюс `expires_in`.
 */
export const saveTokens = (tokens: AuthRefreshToken) => {
  const now = new Date();
  const validUntilDate = new Date(now.getTime() + tokens.expires_in * 1000);
  const valid_until = validUntilDate.toISOString();
  localStorage.setItem(
    STORAGE_KEY_TOKENS,
    JSON.stringify({
      ...tokens,
      valid_until,
    }),
  );
};

/**
 * Получает сохранённые токены из `localStorage`.
 *
 * @returns Объект `AuthStorage` или `null`, если токены отсутствуют или повреждены.
 */
export const getTokens = (): AuthToken | null => {
  const raw = localStorage.getItem(STORAGE_KEY_TOKENS);
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * Удаляет все токены из `localStorage`. Используется при logout или ошибке авторизации.
 */
export const clearTokens = () => {
  localStorage.removeItem(STORAGE_KEY_TOKENS);
};

// ========== CONFIG ==========

/**
 * Сохраняет конфигурацию авторизации в localStorage.
 */
export const saveAuthConfig = (config: AuthConfig) => {
  localStorage.setItem(STORAGE_KEY_CONFIG, JSON.stringify(config));
};

/**
 * Получает конфигурацию авторизации из localStorage.
 */
export const getAuthConfigFromStorage = (): AuthConfig | null => {
  const raw = localStorage.getItem(STORAGE_KEY_CONFIG);
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * Удаляет конфиг сервера аутентификации из `localStorage`. Используется при logout или ошибке авторизации.
 */
export const clearAuthConfig = () => {
  localStorage.removeItem(STORAGE_KEY_CONFIG);
};